/**
 * Wix-embed audit section 14: a versioned, namespaced postMessage
 * protocol — never bare/ambiguous strings, so a stray message from some
 * unrelated script on the host page can never be mistaken for ours.
 */
export const PROTOCOL_SOURCE = "BROTHERS_RESERVATIONS";
export const PROTOCOL_VERSION = 1;

/** Section 4: every DOM node/class this script creates is namespaced, to minimize Wix CSS/JS collisions. */
export const CSS_PREFIX = "brothers-reservations";

/** Section 24: the declarative trigger attribute — `<button data-brothers-reservation>`. */
export const TRIGGER_ATTRIBUTE = "data-brothers-reservation";

/** Section 25: script-tag config attributes. */
export const CONFIG_ATTRIBUTE_BOOKING_URL = "data-booking-url";

/**
 * Owner product correction 2026-09-02: the widget must be SELF-CONTAINED.
 * Installing the script is the whole integration — the loader renders its
 * own persistent launcher, so no Wix button, custom attribute, Velo or Wix
 * JavaScript is required. `data-brothers-reservation` still works for
 * anyone who wants their own trigger, but it is no longer the integration.
 *
 * Set `data-launcher="false"` on the script tag to suppress the built-in
 * launcher (for a host that genuinely wants only its own trigger, and as a
 * way to disable it without removing the script).
 */
export const CONFIG_ATTRIBUTE_LAUNCHER = "data-launcher";

/** Stable id so a second init (or a Wix re-render) can never leave two launchers on the page. */
export const LAUNCHER_ID = `${CSS_PREFIX}-launcher`;

/** Guest-facing label. Dutch is the site's own language; no i18n layer exists in the loader. */
export const LAUNCHER_LABEL = "Reserveren";

/** Section 13: how long to wait for the iframe's READY message before showing an error state. */
export const READY_TIMEOUT_MS = 15_000;

/** Query param the loader appends to the iframe src so the booking app knows which origin to postMessage back to (section 15). */
export const EMBED_ORIGIN_PARAM = "embedOrigin";
